module.exports = __webpack_public_path__ + "img/map-pin.6018183.webp";